




























import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props, TagTypes } from "./types";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import { enumToValues } from "@/helpers/type-helper";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "UniversityTag",
  components: {
    Suffix
  },
  props: {
    university: {
      type: Object as PropType<Props["university"]>,
      required: true
    },
    type: {
      type: String as PropType<Props["type"]>,
      default: TagTypes.Selected,
      validator(value) {
        return enumToValues(TagTypes).includes(value);
      }
    }
  },
  data() {
    return {
      TagTypes
    };
  },
  methods: {
    handleClick() {
      this.$emit("click", this.university);
    }
  }
});
